//
// # useLvsResults Hook
//
// Watches for LVS results from the workspace state.
// Results are stored when the run-lvs tool completes.
//

import { useEffect, useState } from "react";
import { useWorkspace, useWorkspaceSnapshot } from "../../context";
import type { LvsResult } from "./types";

interface LvsResultsState {
  result: LvsResult | null;
  loading: boolean;
}

export function useLvsResults(): LvsResultsState {
  const workspace = useWorkspace();
  const snapshot = useWorkspaceSnapshot();

  const [state, setState] = useState<LvsResultsState>({
    result: null,
    loading: false,
  });

  useEffect(() => {
    // Check if we have LVS results stored in the workspace
    const lvsResult = workspace.getLvsResult?.();
    if (lvsResult) {
      setState({ result: lvsResult, loading: false });
    }
  }, [workspace, snapshot.contentVersion]);

  return state;
}
